export const AI_SETTINGS_NAVIGATION = [
	{ section: 'ai', label: 'Overview & Publish', path: '/settings/ai' },
	{ section: 'ai-knowledge', label: 'Knowledge', path: '/settings/ai/knowledge' },
	{ section: 'ai-skills', label: 'API Skills', path: '/settings/ai/skills' },
	{ section: 'ai-assignments', label: 'Agent Actions', path: '/settings/ai/agent-actions' },
	{ section: 'ai-guardrails', label: 'Guardrails', path: '/settings/ai/guardrails' },
	{ section: 'ai-simulator', label: 'Simulator', path: '/settings/ai/simulator' },
	{ section: 'ai-evaluations', label: 'Evaluations', path: '/settings/ai/evaluations' },
	{ section: 'ai-activity', label: 'Activity', path: '/settings/ai/activity' },
] as const;

export type AiSettingsSection = (typeof AI_SETTINGS_NAVIGATION)[number]['section'];

export function isAiSettingsSection(section: string): section is AiSettingsSection {
	return AI_SETTINGS_NAVIGATION.some((item) => item.section === section);
}

export function aiSettingsPageTitle(
	section: AiSettingsSection,
	knowledgeCollectionName?: string,
): string {
	const label = AI_SETTINGS_NAVIGATION.find((item) => item.section === section)?.label;
	return `AI ${label}${
		section === 'ai-knowledge' && knowledgeCollectionName ? ` → ${knowledgeCollectionName}` : ''
	}`;
}
